import { libraryShareRoutes, reviewUsageRequestRoutes } from './baseRoutes';

/** Keep in sync with pulse-app `PULSE_APP_VIEWS`. */
export const PULSE_APP_VIEWS = {
  PUBLISHED_LIBRARY: 'published-library',
  REVIEW_USAGE_REQUESTS: 'review-usage-requests',
} as const;

export type PulseAppView = (typeof PULSE_APP_VIEWS)[keyof typeof PULSE_APP_VIEWS];

export type PulseOpenRoute = {
  path: string;
  view: PulseAppView;
  title: string;
};

/**
 * Unauthenticated parent routes that embed Pulse with a `view` query param.
 * Add a row here (and a matching page in pulse-app) to ship a new open embed.
 */
export const PULSE_OPEN_ROUTES: PulseOpenRoute[] = [
  {
    path: libraryShareRoutes.path,
    view: PULSE_APP_VIEWS.PUBLISHED_LIBRARY,
    title: 'Published library',
  },
  {
    path: reviewUsageRequestRoutes.path,
    view: PULSE_APP_VIEWS.REVIEW_USAGE_REQUESTS,
    title: 'Review usage requests',
  },
];
